<app-score-dashboard
    class="h-auto overflow-visible"
    [title]="'Appointment Aging'"
    [trendingTitle]="'My Score Trending'"
    [centerText]="'My Score'"
    [showScore]="true"
    [showTrending]="true"
    [showBreakdownCharts] = "false"
    [loadScoreData]="loadScoreData"
    [loadTrendingData]="loadTrendingData"
    [exportData]="exportData"
    [formatMode] = "'percent'"
    [palette]="palette"
    [useCapitalCaseFormatting] = "false"
    [containerClass]="'px-4 pb-4'"
    (dateRangeChanged)="onDateRangeChanged($event)">
</app-score-dashboard>